<template>
    <div>
        <div class="caption font-weight-bold">{{titulo(solucionConstructiva)}}</div>
        <v-list subheader tile dense>
            <v-list-item v-for="(distancia,i) in distancias" :key="i"
                         :class="{'teal accent-3':estaSeleccionada(distancia)}"
                         @click="seleccionarOpcion(distancia)">
                <v-list-item-content v-if="distancia.codigo != 'usuario'">
                    {{distancia.nombre}}
                </v-list-item-content>
                <v-list-item-content v-else>
                    <v-text-field v-model="distanciaUsuario"
                                  @change="actualizaDistanciaUsuario()" outlined hide-details type="number">
                        <template v-slot:prepend-inner>
                            <span class="pr-2">Distancia conocida</span>
                        </template>
                        <template v-slot:append>
                            Km
                        </template>
                    </v-text-field>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
    import DescripcionesServicio from "../../../../../../comunes/servicios/DescripcionesServicio";

    export default {
        name: "InputFabricacionComponente",
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            solucionConstructiva: {type: Object, required: true},
            distancias: {type: Array, required: true},
            correcto: {type: Boolean, default: false}
        },
        data: function () {
            return {
                seleccionado: null,
                distanciaUsuario: 0
            }
        },
        watch: {
            solucionConstructiva: {
                handler(val) {
                    this.cargarDefecto(val);
                    this.emitirCorrecto(this.fabricacionEsCorrecta(val));
                },
                deep: true
            }
        },
        mounted() {
            this.cargarDefecto(this.solucionConstructiva);
            this.emitirCorrecto(this.fabricacionEsCorrecta(this.solucionConstructiva));
        },
        methods: {
            titulo(solCons) {
                return DescripcionesServicio.materialSolCons(solCons);
            },
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            estaSeleccionada(distancia) {
                if (this.seleccionado == null) return false;
                return distancia.codigo == this.seleccionado.codigo;
            },
            seleccionarOpcion(distancia) {
                this.seleccionado = distancia;

                this.solucionConstructiva.distanciaSuministro = distancia.codigo;
                this.solucionConstructiva.distanciaSuministroKm =
                    distancia.codigo == 'usuario' ? this.distanciaUsuario : null;
            },
            actualizaDistanciaUsuario() {
                this.solucionConstructiva.distanciaSuministro = 'usuario';
                this.solucionConstructiva.distanciaSuministroKm = this.distanciaUsuario;
            },
            fabricacionEsCorrecta(solucionConstructiva) {
                if (solucionConstructiva.distanciaSuministro == null) return false;

                if (solucionConstructiva.distanciaSuministro == 'usuario' &&
                    (solucionConstructiva.distanciaSuministroKm == null
                        || solucionConstructiva.distanciaSuministroKm < 1))
                    return false;

                return true;
            },
            cargarDefecto(solucionConstructiva) {
                if (this.seleccionado != null) return;
                if (this.distanciaUsuario != 0) return;

                this.distancias.forEach((distancia) => {
                    if (distancia.codigo == solucionConstructiva.distanciaSuministro)
                        this.seleccionado = distancia;
                });
                this.distanciaUsuario = solucionConstructiva.distanciaSuministroKm;
            }
        }
    }
</script>

<style scoped>

</style>